import { setSessionStorageItem } from '../../../../commons/utils';
import { SESSION_STORAGE_CURRENT_SAILING } from '../../../../commons/constants';

export default (currentSailingVar) => {
  return (newSailing) => {
    currentSailingVar(newSailing);
    setSessionStorageItem(SESSION_STORAGE_CURRENT_SAILING, newSailing);
  };
};
